import { Component, DestroyRef, effect, inject } from '@angular/core';
import { HighlightsComponent } from './highlights/highlights.component';
import { CustomerJourneyComponent } from './customer-journey/customer-journey.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { CreateJourneyComponent } from './create-journey/create-journey.component';
import { RelationshipService } from 'src/app/shared/services/relationship/relationship.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { LtmsLoaderComponent } from 'src/app/shared/components/ltms-loader/ltms-loader.component';
import { catchError, delay, of, retry, tap, timeout } from 'rxjs';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
@Component({
  selector: 'app-relationship-view',
  standalone: true,
  templateUrl: './relationship-view.component.html',
  styleUrls: ['./relationship-view.component.scss'],
  imports: [CustomerJourneyComponent, HighlightsComponent, CreateJourneyComponent, NgClass, NgFor, NgIf, LtmsLoaderComponent]
})
export class RelationshipViewComponent {
  tabs = [
    { key: 'highlights', name: 'Highlights' },
    { key: 'customer_journey', name: 'Customer Journey' }
  ];
  activeTab = this.tabs[0];
  jounrnyList: any = [];
  destroyRef = inject(DestroyRef);
  isLoading: boolean = true;
  isAPIError: boolean = true;
  journeyConfig: any = {};
  errorMessage: string = "We're currently experiencing technical difficulties. Please try again shortly."
  constructor(private _relationshipService: RelationshipService, private _routes: ActivatedRoute, private _router: Router, private _stateService: AppStateService, private _helpers: HelpersService) {
    effect(() => {
      if (this._stateService.initialized()) {
        let accountDetails: any = this._stateService.accountDetails();
        let manuItems = this._helpers.getActiveSideMenu(true, accountDetails._id);
        if(manuItems && !_.isEmpty(manuItems)){
          const tab = _.find(manuItems, (item: any) => item.tabKey == 'relationship');
          if(!(tab && !_.isEmpty(tab))){
            this._router.navigate(['message'], {
              queryParams: { status: '402' },
            });
          }
        }
        if ((accountDetails && _.isEmpty(this.journeyConfig)) || (accountDetails && !_.isEmpty(this.journeyConfig) && this.journeyConfig.account_id !== accountDetails._id)) {
          this.isLoading = true;
          // this.accountId = accountDetails.account_id;
          this.initJourneyConfig(null, accountDetails._id);
        } else if (accountDetails && !_.isEmpty(this.journeyConfig) && this.journeyConfig.account_id == accountDetails._id) {
          this.isLoading = true;
          this.initJourneyConfig(this.journeyConfig, accountDetails._id);
        } else {
          this.jounrnyList = [];
          this.isLoading = false;
        }
      }
    });
    effect(() => {
      let journeyConfig: any = this._relationshipService.journeyConfig();
      if (journeyConfig && !_.isEmpty(journeyConfig) && _.has(journeyConfig, 'configs') && !_.isEmpty(journeyConfig.configs)) {
        this.jounrnyList = journeyConfig.configs;
      } else {
        this.jounrnyList = [];
      }
    })
  }

  initJourneyConfig(journey_config: any, account_id: any) {
    this.isAPIError = false;
    if (!journey_config || _.isEmpty(journey_config)) {
      this._relationshipService.getJourneyConfigByQuery({ account_id: account_id, is_active: true }).pipe(
        takeUntilDestroyed(this.destroyRef),
        timeout(10000),
        retry({
          count: 2,
          delay: (error, retryCount) => {
            return of(null).pipe(delay(2000)); // Wait 2 sec before retrying
          },
        }),
        catchError((err) => {
          this.isAPIError = true;
          this.isLoading = false;
          return of({ error: true, code: -1, data: {} });
        })
      ).subscribe((response: any) => {
        if (_.get(response, 'data.code') == 0 && _.has(response, 'data.journey_config.configs') && !_.isEmpty(response.data.journey_config.configs)) {
          this.jounrnyList = response.data.journey_config.configs;
          this._relationshipService.updateConfig(response.data.journey_config)
        } else {
          this.jounrnyList = [];
        }
        if (this.jounrnyList && this.jounrnyList.length) {
          this.initTab();
        } else {
          this.isLoading = false;
        }
      }, (error: any) => {
        console.log('server error', error);
        this.isAPIError = true;
        this.isLoading = false;
      });
    } else if (journey_config && !_.isEmpty(journey_config)) {
      this.jounrnyList = Helpers.deepClone(journey_config.configs);
      this.initTab();
    } else {
      this.jounrnyList = [];
      this.isLoading = false;
    }
  }

  initTab() {
    this._routes.queryParams.subscribe((params: any) => {
      let activeTab: any = null;
      if (params && params.active_tab) {
        activeTab = this.tabs.find((tab: any) => tab.key === params.active_tab);
      }
      if (!activeTab || _.isEmpty(activeTab)) {
        activeTab = this.tabs[0];
      }
      this.changeTab(activeTab);
    });
  }

  changeTab(tab: any) {
    this.activeTab = tab;
    this._router.navigate([], {
      relativeTo: this._routes,
      queryParams: { active_tab: this.activeTab.key },
      queryParamsHandling: 'merge'
    });
    this.isLoading = false;
  }

  isEditJourneyModal: boolean = false;
  showEditJourneyModal() {
    this.isEditJourneyModal = true;
  }

  closeEditJourneyModal() {
    this.isEditJourneyModal = false;
  }
} 